import React, { useMemo } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Paper,
  Tooltip,
  Popover,
  CircularProgress,
  Avatar,
} from "@material-ui/core";
import { Send, AttachFile } from "@material-ui/icons";
import styles from "./Style.module.css";
import useChatHook from "./Chat.Hook"; // Importing CSS module
import { useSelector } from "react-redux";
import moreGroup from "../../../../../assets/img/ic_more_group.png";
import GroupMenu from "../GroupMenu/GroupMenu.view";
import SidePanelComponent from "../../../../../components/SidePanel/SidePanel.component";
import GroupCreate from "../GroupCreate/GroupCreate.view";
import ChatAvatarItem from "../../../../../components/FloatingChat/ChatAvatarItem.component";
import { Close } from "@material-ui/icons";
import themeImg from "../../../../../assets/img/chatting@2x.png";
import { linkify } from "../../../../../helper/helper";

const ChatComponent = ({
  chatUser,
  setChatUser,
  fetchChatInfo,
  isAuditAdmin,
  renderConversation,
  isFloatingChat
}) => {
  const {
    user: { id: user_id, image },
  } = useSelector((state) => state.auth);

  const {
    handleChangeMessage,
    handleSendMessage,
    profileInfo,
    message,
    conversationData,
    chatMessage,
    chatWindowRef,
    handleFileChange,
    handleClick,
    fileInputRef,
    chatParticipant,
    isGroupChat,
    open,
    id,
    anchorEl,
    handlePopOverClick,
    handleClose,
    sidePanel,
    handleSideToggle,
    loading,
    isMessageDisabled,
    isSubmitting,
    adminUser,
    selectedFiles,
    handleMessageSend,
    setSelectedFiles,
    isDataFetched,
    isAdminCoAdmin
  } = useChatHook({ chatUser, isAuditAdmin, setChatUser, isFloatingChat });

  const userLookup = useMemo(() => {
    if (!isGroupChat || !chatParticipant?.length) return null;

    return chatParticipant.reduce((acc, user) => {
      if (user?.id) acc[user?.id] = user;
      return acc;
    }, {});
  }, [isGroupChat, chatParticipant]);

  return (
    <Box className={styles.chatContainer}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        {!isFloatingChat && (
          <Box className={styles.chatHeader}>
            <div className={styles.nameWrapper}>
              {profileInfo?.display_type &&
              profileInfo?.display_type === "INITIALS" ? (
                <Avatar className={styles.avatarClass}>
                  {profileInfo?.initials?.slice(0, 2)}
                </Avatar>
              ) : (
                <ChatAvatarItem
                  image={profileInfo?.image}
                  initials={profileInfo?.initials}
                  label={profileInfo?.label}
                  displayType={profileInfo?.display_type}
                  size={35}
                />
              )}
              <div>
                <div className={styles.title}>{profileInfo?.label}</div>
                <div className={styles.des}>{profileInfo?.description}</div>
              </div>
            </div>
            {isGroupChat && (
              <div onClick={handlePopOverClick}>
                <img src={moreGroup} alt="img" className={styles.groupImg} />
              </div>
            )}
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              classes={{ paper: styles.popoverPaper }}
            >
              <GroupMenu
                groupId={chatUser?.id}
                handleClosepopOver={handleClose}
                isGroupAdmin={adminUser}
                setChatUser={setChatUser}
                fetchChatInfo={fetchChatInfo}
                isAuditAdmin={isAuditAdmin}
                groupMemberList={conversationData?.participants || []}
                isAdminCoAdmin={isAdminCoAdmin}
                renderConversation={renderConversation}
              />
            </Popover>
          </Box>
        )}
        <div
          className={styles.chatBodyWrapper}
          style={
            isFloatingChat
              ? {
                  flex: 1,
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }
              : {}
          }
        >
          <Box
            ref={chatWindowRef}
            className={styles.chatBody}
            style={
              isFloatingChat
                ? {
                    maxHeight: "none",
                    flex: 1,
                    overflowY: "auto",
                  }
                : {}
            }
          >
            {loading ? (
              <div className={styles.loaderWrap}>
                <CircularProgress className={styles.loader} />
              </div>
            ) : chatMessage?.length > 0 ? (
              chatMessage.map((msg) => {
                const isSender = msg?.sender_id === user_id;
                const senderInfo = isGroupChat
                  ? userLookup[msg?.sender_id]
                  : profileInfo;

                return (
                  <>
                    {msg?.type === "INFO" ? (
                      <Box
                        key={msg?.id}
                        className={styles.messageBox}
                        style={{
                          justifyContent: "center",
                        }}
                      >
                        <div className={styles.infoWrap}>{msg?.message}</div>
                      </Box>
                    ) : (
                      <Box
                        key={msg?.id}
                        className={styles.messageBox}
                        style={{
                          justifyContent: isSender ? "flex-end" : "flex-start",
                        }}
                      >
                        {!isSender && (
                          <div className={styles.profileImage}>
                            <ChatAvatarItem
                              image={senderInfo?.image}
                              initials={senderInfo?.initials}
                              label={senderInfo?.name || senderInfo?.label || "Unknown"}
                              size={30}
                            />
                          </div>
                        )}

                        <div className={styles.titleWrap}>
                          {!isSender && (
                            <div className={styles.title}>
                              {senderInfo?.name ||
                                senderInfo?.label ||
                                "Unknown"}
                            </div>
                          )}

                          <Paper
                            className={
                              isSender
                                ? styles.senderMessage
                                : styles.receiverMessage
                            }
                          >
                            {msg?.doc_path && (
                              <div className={styles.imageWrap}>
                                <a
                                  href={msg?.doc_path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={
                                      /\.(jpe?g|png)$/i.test(msg?.doc_path)
                                        ? msg?.doc_path
                                        : require("../../../../../assets/img/default_file_image@2x.png")
                                    }
                                    className={styles.showImg}
                                    alt="attachment"
                                  />
                                </a>
                                {(msg?.doc_path && !/\.(jpe?g|png|gif|webp)$/i.test(msg?.doc_path)) && (
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      marginTop: "4px",
                                      wordBreak: "break-all",
                                      color: "#000"
                                    }}
                                  >
                                    {(msg?.doc_file_name || msg?.doc_path.split('/').pop() || "").replace(/^\d{13}_/, "")}
                                  </div>
                                )}
                              </div>
                            )}
                            <Typography
                              variant="body2"
                              style={{ whiteSpace: "pre-line", wordBreak: "break-word", overflowWrap: "break-word" }}
                              dangerouslySetInnerHTML={{
                                __html: linkify(msg?.message),
                              }}
                            />

                            <div style={{ textAlign: "end" }}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                {msg?.createdAt}
                              </Typography>
                            </div>
                          </Paper>
                        </div>

                        {isSender && (
                          <div className={styles.profileImage}>
                            <ChatAvatarItem
                              image={image}
                              label="You"
                              size={30}
                            />
                          </div>
                        )}
                      </Box>
                    )}
                  </>
                );
              })
            ) : (
              isDataFetched && (
                <div className={styles.ImgWrap}>
                  <img
                    src={themeImg}
                    className={styles.themeImg}
                    alt="Welcome"
                  />
                  <div className={styles.title}>No Conversations Yet!</div>
                  <div className={styles.des}>
                    Be the first to start the discussion!
                    <br />
                    Share an update, ask a question, or say hello to get things
                    going.
                  </div>
                </div>
              )
            )}
          </Box>
        </div>
      </div>

      <Box className={styles.chatFooter}>
        <div className={styles.fieldWrap}>
          <div className={styles.uploaderWrap}>
            <IconButton
              onClick={handleClick}
              disabled={isSubmitting || isMessageDisabled || isAuditAdmin}
              style={{ padding: "0" }}
            >
              <AttachFile />
            </IconButton>
            <input
              type="file"
              multiple={true}
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
              accept=".pdf, .xlsx, .xls, .docx, .doc, .jpg, .jpeg, .png"
            />
          </div>
          <form
            onSubmit={handleSendMessage}
            className={styles.formField}
            disabled={isSubmitting || isMessageDisabled || isAuditAdmin}
          >
            <div className={styles.chatInputContainer}>
              <TextField
                disabled={isSubmitting || isMessageDisabled || isAuditAdmin}
                className={styles.input}
                placeholder={
                  isMessageDisabled
                    ? "Only Admin can message"
                    : "Type your message"
                }
                multiline
                 maxRows={5}
                // variant="outlined"
                size="small"
                onChange={(e) => handleChangeMessage(e.target.value)}
                value={message}
                onKeyDown={handleSendMessage}
                InputProps={{
                  disableUnderline: true,
                }}
                variant="standard"
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  outline: "none",
                }}
              />
              {selectedFiles?.length > 0 && (
                <div className={styles.filesContainer}>
                  {selectedFiles.map((file, index) => (
                    <div key={index} className={styles.uploadedImage}>
                      <img
                        src={
                          /\.(jpe?g|png)$/i.test(file?.name)
                            ? URL.createObjectURL(file)
                            : require("../../../../../assets/img/default_file_image@2x.png")
                        }
                        alt="Uploaded"
                        style={{
                          width: "100px",
                          height: "auto",
                          borderRadius: "10px",
                        }}
                      />
                      <div
                        style={{
                          width: "100px",
                          fontSize: "12px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          marginTop: "4px",
                          color: "#555"
                        }}
                        title={file?.name}
                      >
                        {file?.name}
                      </div>
                      <IconButton
                        onClick={() => setSelectedFiles(prev => prev.filter((_, i) => i !== index))}
                        className={styles.removeButton}
                      >
                        <Close style={{ fontSize: "14px" }} />
                      </IconButton>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </form>
          <IconButton
            disabled={
              isSubmitting ||
              isMessageDisabled ||
              (!message && selectedFiles.length === 0) ||
              isAuditAdmin
            }
            className={
              isSubmitting ||
              isMessageDisabled ||
              (!message && selectedFiles.length === 0) ||
              isAuditAdmin
                ? styles.disabledCls
                : styles.bgBtn
            }
            // disabled={isSubmitting || isMessageDisabled}
            onClick={handleMessageSend}
          >
            <Send
              className={styles.sendIcon}
              style={{
                color: "#ffffff",
              }}
            />
          </IconButton>
        </div>
        <SidePanelComponent
          handleToggle={handleSideToggle}
          title={"Create New Group"}
          open={sidePanel}
          side={"right"}
        >
          <GroupCreate handleSidePanelToggle={handleSideToggle} />
        </SidePanelComponent>
      </Box>
    </Box>
  );
};

export default ChatComponent;
